const ServiceModal = ({ service, onClose }) => {
  return (
    <>
      <div className="fixed p-15 w-full max-w-[800px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
        <div className="py-10 md:px-10 px-[7px] bg-card-color rounded-lg shadow-shadow-lg">
          <div className="my-10 lg:px-20 md:px-10 px-[7px] md:max-h-[80svh] max-h-[60svh] overflow-auto custom-scrollbar">
            <div className="text-[24px]/[30px] font-medium mb-2">
              {service?.name}
            </div>

            <div className="text-[14px]/[20px] font-medium mb-2">
              <div>{service?.text}</div>
              <div
                className="flex items-stretch gap-5"
                style={{ marginTop: "120px" }}
              >
                <button onClick={onClose} className="btn btn-secondary">
                  დახურვა
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        onClick={onClose}
        className={`contents-[] fixed z-[5] w-full h-full left-0 top-0 bg-black-50 backdrop-blur-[2px]`}
      ></div>
    </>
  );
};

export default ServiceModal;
